import { Routes } from '@angular/router';
import { LoginPage } from '../../core/components/login-page/login-page';
import { Layout } from '../../core/components/layout/layout';
import { HomePage } from '../../core/components/home-page/home-page';
import { alreadyAuthGuard } from '../../core/guards/already-auth.guard';
import { authGuard } from '../../core/guards/auth.guard';
import { permissionGuard } from '../../core/guards/permission.guard';
import { EmployeePermission } from '../constants/permissions';
import {
  ROUTE_LOGIN,
  ROUTE_MAC_APPLICATIONS,
  ROUTE_MAC_DISTRIBUTORS,
  ROUTE_MAC_MANUAL_REVIEW,
  ROUTE_MAC_TERMINATIONS,
  ROUTE_MAC_TRANSACTIONS,
  ROUTE_OPE_DEALERS,
  ROUTE_PLWC_BUYERS,
  ROUTE_PLWC_CREDIT_PLANS,
  ROUTE_PLWC_SUPPLIERS,
  ROUTE_PORTAL_USERS,
} from '../constants/routes';

export const routes: Routes = [
  {
    path: ROUTE_LOGIN,
    component: LoginPage,
    canActivate: [alreadyAuthGuard],
  },
  {
    path: '',
    component: Layout,
    canActivate: [authGuard],
    children: [
      { path: '', component: HomePage, data: { pageTitle: 'Home ' } },
      {
        path: 'mac',
        children: [
          {
            path: ROUTE_MAC_APPLICATIONS,
            loadComponent: () =>
              import('../../features/mac/applications/components/applications-page/applications-page').then(
                (m) => m.ApplicationsPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.APPLICATIONS_ACCESS)],
            data: { pageTitle: 'Applications' },
          },
          {
            path: ROUTE_MAC_DISTRIBUTORS,
            loadComponent: () =>
              import('../../features/mac/distributors/components/distributors-page/distributors-page').then(
                (m) => m.DistributorsPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.SUPPLIERS_ACCESS)],
            data: { pageTitle: 'Suppliers' },
          },
          {
            path: ROUTE_MAC_TRANSACTIONS,
            loadComponent: () =>
              import('../../features/mac/greensky/components/greensky-page/greensky-page').then(
                (m) => m.GreenskyPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.TRANSACTIONS_ACCESS)],
            data: { pageTitle: 'Greensky Transactions' },
          },
          {
            path: ROUTE_MAC_TERMINATIONS,
            loadComponent: () =>
              import('../../features/mac/terminations/components/terminations-page/terminations-page').then(
                (m) => m.TerminationsPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.TERMINATION_ACCESS)],
            data: { pageTitle: 'Terminations' },
          },
          {
            path: ROUTE_MAC_MANUAL_REVIEW,
            loadComponent: () =>
              import('../../features/mac/applications/components/manual-review-page/manual-review-page').then(
                (m) => m.ManualReviewPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.MYSTIC_ACCESS)],
            data: { pageTitle: 'Manual Review' },
          },
        ],
      },
      {
        path: 'plwc',
        children: [
          {
            path: ROUTE_PLWC_CREDIT_PLANS,
            loadComponent: () =>
              import('../../features/plwc/credit-plans/components/credit-plans-page/credit-plans-page').then(
                (m) => m.CreditPlansPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.CREDIT_PLANS_ACCESS)],
            data: { pageTitle: 'Credit Plans' },
          },
          {
            path: ROUTE_PLWC_SUPPLIERS,
            loadComponent: () =>
              import('../../features/plwc/suppliers/components/suppliers-page/suppliers-page').then(
                (m) => m.SuppliersPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.PLWC_ACCESS)],
            data: { pageTitle: 'PLWC Suppliers' },
          },
          {
            path: ROUTE_PLWC_SUPPLIERS + '/:id',
            loadComponent: () =>
              import('../../features/plwc/suppliers/components/supplier-detail-page/supplier-detail-page').then(
                (m) => m.SupplierDetailPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.PLWC_ACCESS)],
            data: {
              headerBreadcrumb: {
                backLabel: 'PLWC Suppliers',
                backRoute: ['/plwc', ROUTE_PLWC_SUPPLIERS],
              },
            },
          },
          {
            path: ROUTE_PLWC_BUYERS,
            loadComponent: () =>
              import('../../features/plwc/buyers/components/buyers-page/buyers-page').then(
                (m) => m.BuyersPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.PLWC_ACCESS)],
            data: { pageTitle: 'PLWC Buyers' },
          },
          {
            path: ROUTE_PLWC_BUYERS + '/:id',
            loadComponent: () =>
              import('../../features/plwc/buyers/components/buyer-detail-page/buyer-detail-page').then(
                (m) => m.BuyerDetailPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.PLWC_ACCESS)],
            data: {
              headerBreadcrumb: {
                backLabel: 'PLWC Buyers',
                backRoute: ['/plwc', ROUTE_PLWC_BUYERS],
              },
            },
          },
        ],
      },
      {
        path: 'ope',
        children: [
          {
            path: ROUTE_OPE_DEALERS,
            loadComponent: () =>
              import('../../features/ope/dealers/components/dealers-page/dealers-page').then(
                (m) => m.DealersPage,
              ),
            canActivate: [permissionGuard(EmployeePermission.OPE_ACCESS)],
            data: { pageTitle: 'OPE Dealers' },
          },
        ],
      },
      {
        path: ROUTE_PORTAL_USERS,
        loadComponent: () =>
          import('../../features/portal/employees/components/users-page/users-page').then(
            (m) => m.UsersPage,
          ),
        canActivate: [permissionGuard(EmployeePermission.USERS_ACCESS)],
        data: { pageTitle: 'Users' },
      },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
